import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { UpdateWell, UpdateWellOwner } from '../../../UpdateData/UpdateCommunications';
import { loadingOwnerWellDataComponent } from '../../../LoadingData/LoadingDataComponents';
import ChangeCoordManuallyDialog from './ChangeCoordManuallyDialog';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import { WELL, WELL_FLAG } from '../../../Constants/ConstantsOptics';
import { UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';
import DialogWellFotoEditing from '../DialogFoto/DialogWellFotoEditing';

const WellCantonEditingDialog = ({ open, onClose, onClose2, content, highwayRefresh, setIsComponentСhangeCoor, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, user}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [ownerWellData, setOwnerWellData] = useState([]); 
  const [ownerWellId, setOwnerWellId] = useState("");
  const [selectedOwnerPrice, setSelectedOwnerPrice] = useState(content.ownerWellPrice);
  const [openModalChangeCoord, setOpenModalChangeCoord] = useState(false);
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 


  const openModalChangeCoordinate = () => {
    setOpenModalChangeCoord(true);
  }; 

  const openModalFotoFile = () => {
    setOpenModalFoto(true);
  }; 

  //загрузка OwnerWell
  useEffect(() => {
    const fetchOwnerWellData = async () => {
      try {
        const data = await loadingOwnerWellDataComponent();
        setOwnerWellData(data);
      } catch (error) {
       // console.error("Error in fetchOwnerWellData:", error);
      }
    };
    fetchOwnerWellData(); 
  }, []); 

  const deleteWell = () => {
    UpdateStatusComponents(WELL, content.id, showSnackbar, user, highwayRefresh, handleCloseDialogs );
  };

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };

  const updateWell = () => {
    if (statusChange) {
      UpdateWell(content.id, textComment, showSnackbar,content.authorId, highwayRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangeWellOwnerSelect = (event) => {
    const selectedWellOwner = event.target.value;
    if (selectedWellOwner === "") {
      setOwnerWellId("");
      setSelectedOwnerPrice(null);
    } else {
      const selectedWellOwner2 = ownerWellData.find(wellOwner => 
        `${wellOwner.id}` === selectedWellOwner
      );
      if (selectedWellOwner2) {
        setOwnerWellId(selectedWellOwner2.id);
        setSelectedOwnerPrice(selectedWellOwner2.price);
      }
    }
  };

  const updateWellOwner = () => {
    if (ownerWellId === "") {
      showSnackbar('Нет нужды в записи, собственник без изменений!', 'snackbarOk');
    } else {
      UpdateWellOwner(content.id, ownerWellId, showSnackbar,content.authorId, highwayRefresh );
    } 
  };

  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoor(true);
  }

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      <img src='./manhole.png'  width='30' height='30' style={{marginRight: "5px"}}/>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование колодца</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>  
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeWellOwnerSelect(event);
          }} >
          <option value="">{content.ownerWellName}</option>
          {ownerWellData.map(owner => (
            <option key={owner.id} value={owner.id}>{owner.name}</option>
          ))}
        </select>
        <button onClick={updateWellOwner} class='buttonIsSaveDialog2'>Сохранить</button>

      {/* <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>  */}
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тариф/км: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{selectedOwnerPrice} грн.</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>  
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />
        <br/>
         <button onClick={updateWell} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>
     
         <hr className='horizontalLineDialog'/>
          <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}>Редактировать на карте</button>
          <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
        <button  class='buttonIsEditDialog' onClick={openModalChangeCoordinate}>Изменить координаты вручную</button>
        <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
        <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
        <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
        <button  class='buttonIsEditDialog' onClick={openModalFotoFile}> Редактирование файлов</button>
        <hr className='horizontalLineDialog'/>

        <button 
          className="buttonIsDeleteModal" 
          onClick={deleteWell} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" }}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
          }}
        >
        Восстановление доступно в течение 24 часов
      </span>

     
      <hr className='horizontalLineDialog'/>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>

      <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={WELL}
          flag={WELL_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

        {/* Modal Foto*/}
        <DialogWellFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          user={content.authorId}     
        />   

      <ChangeCoordManuallyDialog
         open={openModalChangeCoord}
         onClose={() => setOpenModalChangeCoord(false)}
         id={content.id}   
         user={content.authorId}
         cantonRefresh={highwayRefresh}
         flag={WELL}
        /> 

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={6000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
    </Dialog>
  );
}

export default WellCantonEditingDialog;